import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { RWebShare } from "react-web-share";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import Swal from "sweetalert2";
import { requestSaleOrderList, requestStatusSaleorderUpdate, requestSaleorderDelete, requestCreateInvoiceSaleorder } from "../../Redux/actions";
import Footer from './../footer';
import PageHeader from './../header';
import Sidebar from './../Sidebar';
import '../../Admin/style.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import DataTable from 'react-data-table-component';
import ContactView from "./../ContactBook/ContactView";
import ProductSaleOrder from "./../SaleOrder/ProductSaleOrder";
import { usePwaInstall } from './../../hooks/usePwaInstall';

function SaleOrderList(props) {
    const params = useParams();
    const [jobs, setjobs] = useState([]);
    // const [pagination, setpagination] = useState({});
    const navigate = useNavigate();
    const [pages, setpages] = useState([]);
    const [page_size, setpage_size] = useState(10);
    const [change, setchange] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState([]);
    const [logindetails, setlogindetails] = useState({});
    const [statusdata, setstatusdata] = useState({ status: 0 });
    const [typingTimeout, setTypingTimeout] = useState(0);
    const [id, setid] = useState(0);
    const [statusmodal, setstatusModal] = useState(false);
    const [contactmodal, setcontactModal] = useState(false);
    const [productModal, setproductModal] = useState(false);
    const [clientName, setclientName] = useState('');
    const [clientId, setclientId] = useState(0);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [checked_all, setCheckedAll] = useState(false);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { isInstallable, triggerInstall } = usePwaInstall();

    const HandleCreateInvoice = () => {
        if (selectedCheckboxes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Selection',
                text: 'Please select at least one job to create an invoice.',
            });
            return;
        }
        Swal.fire({
            title: 'Create Invoice',
            text: `Are you sure you want to create an invoice for ${selectedCheckboxes.length} selected job(s)?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, create invoice!'
        }).then((result) => {
            if (result.isConfirmed) {
                props.requestCreateInvoiceSaleOrder({
                    data: {
                        param1: selectedCheckboxes.join(','),
                        param2: localStorage.getItem('companyToken'),
                        token: logindetails.data.userToken
                    },
                });
            }
        });
    };

    useEffect(() => {
        let invoiceData = props.data.createInvoiceSaleOrderData;
        if (invoiceData !== undefined) {
            if (invoiceData.data.status === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: 'Invoice created successfully.',
                    icon: 'success'
                });
                setchange(!change);
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: invoiceData.data.message,
                    icon: 'error'
                });
            }
            props.data.createInvoiceSaleOrderData = undefined;
        }
    }, [props.data.createInvoiceSaleOrderData]);

    const HandlePaymentRequest = () => {
        if (selectedCheckboxes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Selection',
                text: 'Please select at least one job to request payment.',
            });
            return;
        }
        Swal.fire({
            title: 'Payment Request',
            text: `Are you sure you want to request payment for ${selectedCheckboxes.length} selected job(s)?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, request payment!'
        }).then((result) => {
            if (result.isConfirmed) {
                props.requestPayments({
                    data: {
                        param1: selectedCheckboxes.join(','),
                        //      token: localStorage.getItem('companyToken'),
                        param2: localStorage.getItem('companyToken'),//'611337539322',
                        token: logindetails.data.userToken
                    },
                });
                // Swal.fire(
                //   'Payment Requested!',
                //   `${selectedCheckboxes.length} job(s) have been requested for payment.`,
                //   'success'
                // );
            }
        });
    };

    useEffect(() => {
        let paymentData = props.data.razorData;
        if (paymentData !== undefined) {
            if (paymentData.data === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: 'Payment request sent successfully.',
                    icon: 'success'
                });
                setchange(!change);
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: paymentData.data.message,
                    icon: 'error'
                });
            }
            props.data.razorData = undefined;
        }
    }, [props.data.razorData]);

    const HandlyPaymentCheck = () => {
        props.requestPaymentCheck({
            data: {
                //      token: localStorage.getItem('companyToken'),
                param1: localStorage.getItem('companyToken'), //'611337539322',
                token: logindetails.data.userToken
            },
        });
    }

    const HandlyAddSaleOrder = () => {
        navigate('/saleorderadd');
    }

    useEffect(() => {
        let paymentCheckData = props.data.paymentCheckData;
        if (paymentCheckData !== undefined) {
            if (paymentCheckData.data.status === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: 'Payment check completed successfully.',
                    icon: 'success'
                });
                setchange(!change);
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: paymentCheckData.data.message,
                    icon: 'error'
                });
            }
            props.data.paymentCheckData = undefined;
        }
    }, [props.data.paymentCheckData]);



    // Function to handle individual checkbox change
    const handleCheckboxChange = (id) => {
        console.log("Checkbox clicked:", id);
        const updatedCheckboxes = selectedCheckboxes.includes(id)
            ? selectedCheckboxes.filter((checkboxId) => checkboxId !== id)
            : [...selectedCheckboxes, id];
        setSelectedCheckboxes(updatedCheckboxes);
    };

    const Checkbox = ({ id, isChecked, onChange, name, value }) => (
        <input type="checkbox" name={name} value={value} id={id} checked={isChecked} onChange={() => onChange(id)} />
    );

    // Function to handle "Select All" checkbox change
    const handleSelectAllChange = () => {
        const allCheckboxIds = filter.map((item) => item.saleorderId);
        setSelectedCheckboxes((prevSelected) =>
            prevSelected.length === allCheckboxIds.length ? [] : allCheckboxIds
        );
    };

    const contacttoggle = (id) => {
        if (contactmodal === true) {
            setcontactModal(!contactmodal);
        } else {
            setcontactModal(!contactmodal);
            setid(id);
        }
    };

    const producttoggle = (id, name) => {
        if (productModal === true) {
            setproductModal(!productModal);
        } else {
            setproductModal(!productModal);
            setid(id);
            setclientName(name);
        }
    };

    const onchangestatusdata = (event, param1) => {
        setstatusdata((statusdata) => ({
            ...statusdata,
            [event.target.name]: event.target.value,
        }));
    };

    const statustoggle = (id) => {
        if (statusmodal === true) {
            setstatusModal(!statusmodal);
        } else {
            setstatusModal(!statusmodal);
            setid(id);
            //        setstatusdata({ status: 0 });
            // props.requestStatusSaleOrderUpdate({
            //   param1: id,
            //   param2: statusdata.status,
            //   token: logindetails.token,
            // });
        }
    };

    const savestatustoggle = (e) => {
        e.preventDefault();
        props.requestStatusSaleorderUpdate({
            data: {
                param1: id.toString(),
                param2: statusdata.status,
                token: logindetails.data.userToken
            },
        });
        console.log(logindetails.data.userToken);
        setid(0);
        statustoggle();
    }

    useEffect(() => {
        let statusJobData = props.data.updateSOData;
        if (statusJobData !== undefined) {
            if (statusJobData?.data?.status == 1) {
                Swal.fire(
                    "Good job!",
                    "Sale Order Status Updated Successfully.",
                    "success"
                );
                props.data.updateSOData = undefined;
                setstatusdata({ status: 0 });
                setchange(!change);
            } else {
                Swal.fire("Error!", `${statusJobData.data.message}`, "error");
                props.data.updateSOData = undefined;
            }
        }
    }, [props.data.updateSOData]);

    const handleSearch = (event) => {
        console.log(event.target.value);
        setSearch(event.target.value);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensures 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day} / ${month} / ${year}`;
    };

    const conditionalRowStyles = [
        {
            when: row => row.razorpayStatus === 'paid',
            style: {
                backgroundColor: '#d4edda', // light green
                color: '#155724',           // dark green text
                fontWeight: 'bold'
            }
        }
    ];

    const columns = [
        {
            name: 'Select',
            cell: item => <div>
                <Checkbox id={item.saleorderId} name="select" value={item.saleorderId} onChange={() => handleCheckboxChange(item.saleorderId)} isChecked={selectedCheckboxes.includes(item.saleorderId)}></Checkbox>
            </div>,
            selector: item => item.id,
            width: '1%'
        },
        {
            name: 'Dates',
            cell: item => <div><h6>{item.date}</h6></div>,
            selector: item => item.saleorderDate,
            width: '15%'
        },
        {
            name: 'Customer',
            cell: item => <div><a href={'/admin/viewCompany/' + item.clientId}></a>
                <div>
                    <a onClick={() => { contacttoggle(item.clientId); }}>
                        {/* <button
                            class={'badge ' + (item.status === "Fullfilled" ? 'badge-opacity-success' : item.status === "Open" ? 'badge-opacity-dark' : item.status === "Hold" ? 'badge-opacity-warning' : item.status === "Cancelled" ? 'badge-opacity-danger' : 'badge-opacity-light')}
                            style={{ border: "0px" }}
                        >
                        </button> */}
                        {item.clientName}
                    </a>
                    {contactmodal === true && (
                        <Modal
                            isOpen={contactmodal}
                            toggle={contacttoggle}
                        >
                            <ModalHeader toggle={contacttoggle}>
                                Contact Details
                            </ModalHeader>
                            <ModalBody>
                                <ContactView props={id}></ContactView>
                            </ModalBody>
                        </Modal>
                    )}
                    <p>
                        <i class="fa fa-phone"></i> <a href={`callto:${item.clientMobile}`}>{item.clientMobile}</a>
                    </p>
                </div>
            </div>,
            selector: item => item.clientId,
            width: '18%'
        },
        {
            name: 'Order',
            cell: item =>
                <div>
                    <a onClick={() => { producttoggle(item.token, item.clientName); }}>
                        <button style={{ border: "4px", padding: "4px" }}><h6>{item.item}</h6><p>₹ {item.total}</p></button>
                    </a>
                    <p>{item.itemCount} items</p>
                    {productModal === true && (
                        <Modal style={{ maxWidth: "80%" }}
                            isOpen={productModal} backdrop="static"
                            toggle={producttoggle} keyboard={false}
                        >
                            <ModalHeader toggle={producttoggle}>
                                Product Details for {clientName}
                            </ModalHeader>
                            <ModalBody>
                                <ProductSaleOrder props={id} cname={clientName} onClose={() => producttoggle(item.token, item.clientName)} saleorderId={id}></ProductSaleOrder>
                            </ModalBody>
                        </Modal>
                    )}</div>
            ,
            selector: item => item.token,
            width: '18%'
        },
        {
            name: 'Action',
            cell: item => <div>
                {logindetails["job_status"] != 0 ?
                    <a onClick={() => { statustoggle(item.id); }} title="Change Status">
                        <button
                            class={'badge ' + (item.status === "Fullfilled" ? 'badge-opacity-success' : item.status === "Open" ? 'badge-opacity-dark' : item.status === "Hold" ? 'badge-opacity-warning' : item.status === "Cancelled" ? 'badge-opacity-danger' : 'badge-opacity-light')}
                            style={{ border: "0px" }}
                        >
                            <i class="fa fa-toggle-on"></i>
                        </button>
                    </a>

                    : ''}
                {statusmodal === true && (
                    <Modal
                        isOpen={statusmodal}
                        toggle={statustoggle}
                    >
                        <ModalHeader toggle={statustoggle}>
                            Change Status of the Job
                        </ModalHeader>
                        <ModalBody>
                            <form class="forms-sample">
                                <div class="item">
                                    <div class="col-lg-12 col-md-12">
                                        <div class="form-group">
                                            <label>Status</label>
                                            <select
                                                class="form-select"
                                                name="status"
                                                value={statusdata.status}
                                                onChange={event => onchangestatusdata(event, item.status)}
                                            >
                                                <option value="Open">Pending</option>
                                                <option value="Hold">Hold</option>
                                                <option value="Fullfilled">Fullfilled</option>
                                                <option value="Cancelled">Cancelled</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    type="submit" class="btn btn-primary me-2" onClick={savestatustoggle} >
                                    Submit
                                </button>
                                <button
                                    class="btn btn-light"
                                    onClick={statustoggle}
                                >
                                    Cancel
                                </button>
                            </form>
                        </ModalBody>
                    </Modal>
                )}
                {JSON.parse(localStorage.getItem("user")).data.saleorder_delete != 0 ?
                    <button class="badge badge-opacity-danger" style={{ border: "0px", background: "#fea8a9", marginLeft: "5px", }}
                        onClick={() => { deletedata(item.id); }}><i class="fa fa-trash"></i></button> : ''
                }
            </div>,
            selector: item => item.id,
            width: '100px'
        },
    ];

    function deletedata(id) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                props.requestSaleorderDelete({
                    data: {
                        userToken: logindetails.data.userToken,
                        cart_Id: id.toString()
                    },
                });
            }
        })
    }

    //delete
    useEffect(() => {
        let deleteSaleOrderData = props.data.deleteSaleOrderData;
        if (deleteSaleOrderData !== undefined) {
            if (deleteSaleOrderData.data) {
                Swal.fire({
                    title: 'Good job!',
                    text: 'Sale Order deleted successfully..',
                    icon: 'success'
                });
                setchange(!change)
            }
        }
        props.data.deleteSaleOrderData = undefined;
    }, [props.data.deleteSaleOrderData]);

    useEffect(() => {
        let data1 = JSON.parse(localStorage.getItem("user"));
        if (data1) {
            setlogindetails(data1);
            props.requestSaleOrderList({
                //      token: localStorage.getItem('companyToken'),
                token: localStorage.getItem('companyToken'), //'611337539322',
                page: params.page,
                page_size: params.page_size,
                search: 'a'
            });
        }
        setpage_size(params.page_size);
    }, [params.page, params.page_size, change]);

    function onChangePageSize(e) {
        setpage_size(e.target.value);
        if (e.target.value > 0) {
            navigate(`/saleorder/1/${e.target.value}`);
        }
    }

    //set job list
    useEffect(() => {
        let jobsData = props.data.saleorderData;
        console.log(jobsData);
        if (jobsData !== undefined) {
            if (jobsData.data) {
                setjobs(jobsData.data.data);
                setFilter(jobsData.data.data);
                // setTotalRows(jobsData.data.meta.total);
            }
        }
    }, [props.data.saleorderData]);

    const handlePageChange = page => {
        console.log(page);
        props.requestSaleOrderList({
            page: page,
            page_size: page_size,
            search: ''
        });
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setpage_size(newPerPage);
        props.requestSaleOrderList({
            page: page,
            page_size: newPerPage,
            search: ''
        });
    }

    function printPage() {
        var printContents = "<br/><center><h3>Jobs</h3></center>" + document.getElementById("printme").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }

    const tableHeaderStyle = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    }

    return (
        <div class="container-scroller">
            {/* <PageHeader name="Jobs" /> */}
            <div class="container-fluid page-body-wrapper">
                <Sidebar name="Jobs" />
            {                
                isInstallable === true &&
                    (<button className="install-button" onClick={triggerInstall}>
                        🚀 Install App
                    </button>)
            }

                <div class="main-panel">
                    <div class="content-wrapper">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="home-tab">
                                    <div class="row flex-grow">
                                        <div class="col-12 grid-margin stretch-card">
                                            <div class="card card-rounded">
                                                <div class="card-body">
                                                    <div class="d-sm-flex justify-content-between align-items-start">
                                                        <div class="btn-wrapper">
                                                            <RWebShare
                                                                data={{
                                                                    text: "BookkeeperDay - Your Personal Bookkeeping App",
                                                                    url: `${baseUrl}/saleorder/${params.page}/${params.page_size}`,
                                                                    title: "SaleOrder List",
                                                                }}
                                                            >
                                                                <p class="btn btn-otline-dark align-items-center"><i class="icon-share"></i> Share</p>
                                                            </RWebShare>
                                                            <button onClick={printPage} class="btn btn-otline-dark"><i class="icon-printer"></i> Print</button>
                                                            <label htmlFor="search">Status Color codes : </label>
                                                            <button class='badge' style={{ border: "0px", backgroundColor: '#d4edda', color: '#155724' }}>Paid</button>
                                                            <button class='badge badge-opacity-success' style={{ border: "0px" }}>Fullfilled</button>
                                                            <button class='badge badge-opacity-dark' style={{ border: "0px" }}>Pending</button>
                                                            <button class='badge badge-opacity-warning' style={{ border: "0px" }}>Hold</button>
                                                            <button class='badge badge-opacity-danger' style={{ border: "0px" }}>Cancelled</button>
                                                        </div>
                                                    </div>
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <Row>
                                                                <div class="col-md-3">
                                                                    <Checkbox id="selectAll" isChecked={selectedCheckboxes.length === page_size} onChange={handleSelectAllChange} /> Select All
                                                                </div>
                                                                {/* <div class="col-md-3">
                                                                        <button class="btn btn-danger" style={{ color: '#fff' }} onClick={() => { HandleCreateInvoice(); }}>Create Invoice</button>
                                                                    </div>
                                                                    <div class="col-md-3">
                                                                        <button class="btn btn-primary" style={{ color: '#fff' }} onClick={() => { HandlePaymentRequest(); }}>Payment Request</button>
                                                                    </div>
                                                                    <div class="col-md-3">
                                                                        <button class="btn btn-warning" style={{ color: '#fff' }} onClick={() => { HandlyPaymentCheck(); }}>Check Payments</button>
                                                                    </div> */}
                                                            </Row>
                                                            <button class="btn btn-primary" style={{ color: '#fff' }} onClick={() => { HandlyAddSaleOrder(); }}>Add SaleOrder</button>
                                                        </div>
                                                    </div>
                                                    <div class="table-responsive  mt-1" id="printme">
                                                        <DataTable
                                                            columns={columns}
                                                            data={filter}
                                                            pagination
                                                            paginationServer
                                                            paginationTotalRows={totalRows}
                                                            onChangePage={handlePageChange}
                                                            onChangeRowsPerPage={handlePerRowsChange}
                                                            actions={<button className="btn btn-success">Export to PDF</button>}
                                                            subHeader
                                                            subHeaderComponent={
                                                                <input id="search" type="text" className="w-25 form-control" placeholder="Search..." value={search} onChange={handleSearch} />
                                                            }
                                                            customStyles={tableHeaderStyle}
                                                            conditionalRowStyles={conditionalRowStyles}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <Footer /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestSaleOrderList, requestStatusSaleorderUpdate, requestSaleorderDelete, requestCreateInvoiceSaleorder }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SaleOrderList);